module.exports = __webpack_public_path__ + "static/media/img-xkCoach-explain.74c4102e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-xkCoach-explain.svg
// module id = 945
// module chunks = 0